import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

//状态管理
const store = new Vuex.Store({
    state: {
        userInfo : {},
        systemConfig : {},
    },
    mutations: {
        updateUserInfo(state, info) {
            state.userInfo = info;
        },
        updateSystemConfig(state, config) {
            state.systemConfig = config;
        },
    }
});

export default store;